import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import { DialogAnimate } from '../../animate';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack5';

// material
import { useTheme } from '@material-ui/core/styles';

import {
    Card,
    Table,
    Stack,
    Button,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    TablePagination,
    Grid,
    TextField,
    ListSubheader,
    Autocomplete

} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../../redux/store';
// routes
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Label from '../../Label';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import HeaderBreadcrumbs from '../../HeaderBreadcrumbs';
import { QueueListHead } from '../../_dashboard/services';
import apiPbx from '../../../api/pbx';
import apiContact from '../../../api/contact';
import DialogPlayRecord from '../../../pages/pbx/DialogPlayRecord';
import axios from 'axios';
import moment from 'moment';
import DialogNoteOfCall from '../../../pages/pbx/DialogNoteOfCall';

// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}



export default function CallHistory({ phone }) {
    const { enqueueSnackbar } = useSnackbar();
    const [isOpenModalPlayRecord, setIsOpenModalPlayRecord] = useState(false);
    const [isOpenModalNoteOfCall, setIsOpenModalNoteOfCall] = useState(false);
    const [urlRecord, setUrlRecord] = useState();
    const [callIdRecord, setCallIdRecord] = useState('');
    const { t } = useTranslation();
    const { themeStretch } = useSettings();
    const theme = useTheme();
    const dispatch = useDispatch();
    const [historyList, setHistoryList] = useState([]);
    const [startHistory, setStartHistory] = useState(0);
    const [totalHistory, setTotalHistory] = useState(0);
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState('name');
    const [filterName, setFilterName] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [listContact, setListContact] = useState([]);
    const [values, setValues] = useState({phone:phone,limit:rowsPerPage,start:startHistory});


    const TABLE_CALL_HISTORY = [
        { id: 'calldate', label: t('call_date'), alignRight: false },
        { id: 'caller', label: t('caller'), alignRight: false },
        { id: 'callee', label: t('callee'), alignRight: false },
        { id: 'status', label: t('status'), alignRight: false },
        { id: 'duration', label: t('duration'), alignRight: false },
        { id: 'billsec', label: t('billsec'), alignRight: false },
        { id: 'did', label: t('did'), alignRight: false },
        { id: 'type', label: t('type_call'), alignRight: false },
        { id: '', label: "Nghe/Tải ghi âm", alignRight: false },
        // { id: '', label: t('listen_record'), alignRight: false },
        // { id: '', label: t('download_record'), alignRight: false },
        { id: 'notes', label: t('notes'), alignRight: false }
    ];
    const loadCallHistory = async (startHistory) => {
        const res = await apiPbx.find_call_history(values);
        setHistoryList(res.data.data.data);
        setTotalHistory(res.data.data.meta.total);
    }

    const listContactSys = async () => {
        const res = await apiContact.view();
        console.log(res.data.data);
        setListContact(res.data.data);
    }
    useEffect(() => {
        listContactSys();
        // const loadCallHistory = async (startHistory) => {
        //     values['start'] = startHistory;
        //     values['limit'] = rowsPerPage;
        //     values['phone'] = phone;
        //     const res = await apiPbx.find_call_history_quick(values);
        //     console.log(values);
        //     setHistoryList(res.data.data.data);
        //     setTotalHistory(res.data.data.meta.total);
        // }
        loadCallHistory(startHistory);
    }, []);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const handleChangePage = async (event, newPage) => {
        setPage(newPage);
        const start = (startHistory + newPage) * rowsPerPage;
        values['start'] = start;
        values['limit'] = rowsPerPage;
        values['phone'] = phone;
     
        const res = await apiPbx.find_call_history_quick(values);
        setHistoryList(res.data.data.data);
        setTotalHistory(res.data.data.meta.total);
    };

    const handleChangeRowsPerPage = async (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        values['start'] = startHistory;
        values['limt'] = parseInt(event.target.value, 10);
        values['phone'] = phone;
        const res = await apiPbx.find_call_history_quick(values);
        setHistoryList(res.data.data.data)
        setTotalHistory(res.data.data.meta.total);
    };

    // const handleFilterByName = (event) => {
    //     setFilterName(event.target.value);
    // };


    const currentDate = new Date();
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    // const formattedDate = currentDate.toLocaleDateString('en-US', options);

    const filteredHistory = applySortFilter(historyList, getComparator(order, orderBy), filterName);
    const isHistoryNotFound = filteredHistory.length === 0;
    const statusHistory = (status) => {
        if (status === "ANSWERED") {
            return (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Icon icon="ic:round-phone-in-talk" />
                    <Label
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color={"success"}
                    >
                        {t('answered')}
                    </Label>
                </Stack>
            );
        } else if (status === "BUSY") {
            return (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Icon icon="ic:round-phone-paused" />
                    <Label
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color={"warning"}
                    >
                        {t('call_busy')}
                    </Label>
                </Stack>
            );
        } else if (status === "MISSED") {
            return (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Icon icon="ic:round-phone-missed" />
                    <Label
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color={"secondary"}
                    >
                        {t('call_missed')}
                    </Label>
                </Stack>
            );
        } else if (status === "FAILED") {
            return (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Icon icon="ic:sharp-phone-disabled" />
                    <Label
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color={"error"}
                    >
                        {t('call_failed')}
                    </Label>
                </Stack>
            );
        } else {
            return (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Icon icon="ic:round-settings-phone" />
                    <Label
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color={"primary"}
                    >
                        {t('no_answer')}
                    </Label>
                </Stack>
            );
        }
    };
    const formatCalldate = (type, calldate) => {
        const dateTime = new Date(calldate);
        const date = dateTime.toLocaleDateString();
        const time = dateTime.toLocaleTimeString();
        if (type === 'inbound') {
            return (
                <>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        {/* <Icon icon="uil:calender" /> */}
                        <Typography variant="subtitle2"> {date}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center">
                        {/* <Icon icon="solar:incoming-call-bold" color="#0df505" /> */}
                        <Typography variant="body2" sx={{ color: 'text.secondary' }} > {time}</Typography>
                    </Stack>
                </>
            );
        } else if (type === 'outbound') {
            return (
                <>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        {/* <Icon icon="uil:calender" /> */}
                        <Typography variant="subtitle2"> {date}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center">
                        {/* <Icon icon="solar:outgoing-call-bold" color="#f50505" /> */}
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}> {time}</Typography>
                    </Stack>
                </>
            );
        } else {
            return (
                <>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        {/* <Icon icon="uil:calender" /> */}
                        <Typography variant="subtitle2"> {date}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center">
                        {/* <Icon icon="solar:end-call-bold-duotone" color="#0525f5" /> */}
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}> {time}</Typography>
                    </Stack>
                </>
            );
        }
    };

    // const typeFormat = (type) => {
    //     if (type == 'inbound') {
    //         return (
    //             <>
    //                 <Stack direction="row" alignItems="center">
    //                     <Icon icon="solar:incoming-call-bold" color="#0df505" />
    //                     <Typography variant="body2" sx={{ color: 'text.secondary' }} > {t('incoming_call')}</Typography>
    //                 </Stack>
    //             </>
    //         );
    //     } else if (type == 'outbound') {
    //         return (
    //             <>
    //                 <Stack direction="row" alignItems="center">
    //                     <Icon icon="solar:outgoing-call-bold" color="#f50505" />
    //                     <Typography variant="body2" sx={{ color: 'text.secondary' }}> {t('outgoing_call')}</Typography>
    //                 </Stack>
    //             </>
    //         );
    //     } else {
    //         return (
    //             <>
    //                 <Stack direction="row" alignItems="center">
    //                     <Icon icon="solar:end-call-bold-duotone" color="#0525f5" />
    //                     <Typography variant="body2" sx={{ color: 'text.secondary' }}> {t('local')}</Typography>
    //                 </Stack>
    //             </>
    //         );
    //     }
    // };
    const typeFormat = (type, note) => {
        if (type === 'inbound') {
            return (
                <>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Icon icon="solar:incoming-call-bold" color="#0df505" />
                        <Typography variant="body2" sx={{ color: 'text.secondary' }} > {t('incoming_call')}</Typography>
                    </Stack>
                    { note && note?.includes("Transfer") ? <Stack direction="row" alignItems="center">
                        <Icon icon="entypo:forward" color="#556ee6" />
                        <Typography variant="body2" sx={{ color: 'text.secondary' }} > {note}</Typography>
                    </Stack> : null}
                </>
            );
        } else if (type === 'outbound') {
            return (
                <>
                    <Stack direction="row" alignItems="center">
                        <Icon icon="solar:outgoing-call-bold" color="#f50505" />
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}> {t('outgoing_call')}</Typography>
                    </Stack>
                    { note && note?.includes("Transfer") ? <Stack direction="row" alignItems="center">
                        <Icon icon="entypo:forward" color="#556ee6" />
                        <Typography variant="body2" sx={{ color: 'text.secondary' }} > {note}</Typography>
                    </Stack> : null}
                </>
            );
        } else {
            return (
                <>
                    <Stack direction="row" alignItems="center">
                        <Icon icon="solar:end-call-bold-duotone" color="#0525f5" />
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}> {t('local')}</Typography>
                    </Stack>
                    { note && note?.includes("Transfer") ? <Stack direction="row" alignItems="center">
                        <Icon icon="entypo:forward" color="#556ee6" />
                        <Typography variant="body2" sx={{ color: 'text.secondary' }} > {note}</Typography>
                    </Stack> : null}
                </>
            );
        }
    };

    const convertStringToTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secondsRemainder = seconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secondsRemainder.toString().padStart(2, '0')}`;
    };

    const handleCloseModalPlayRecord = () => {
        setIsOpenModalPlayRecord(false);
    }

    const handlePlayRecord = (callid) => {
        setIsOpenModalPlayRecord(true);
        setCallIdRecord(callid);
    }

    const handleDownload = async (audioUrl, callid) => {
        const dateDownload = new Date();
        const response = await fetch(audioUrl);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${callid}-${dateDownload.getTime()}.ogg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const handleDownloadRecord = async (callid) => {
        try {
            // 1682392001.264839
            let f = await apiPbx.download_record({ 'callid': callid });
            console.log(f.data.data);
            if (f.status === 200) {
                handleDownload(f.data.data, callid);
            }
            enqueueSnackbar(t('downloading_file'), { variant: 'success' });
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    }

    const handleOpenDialogNoteOfCall = (callid) => {
        setIsOpenModalNoteOfCall(true);
        setCallIdRecord(callid);
    }

    const handleCloseModalNoteOfCall = () => {
        setIsOpenModalNoteOfCall(false);
    }

    const checkAnsweredPlay = (callid, status) => {
        if (status === 'ANSWERED') {
            return (
                <Button onClick={() => handlePlayRecord(callid)}><Icon icon="icon-park-solid:play" color="#0045FF" width="30px" height="30px" /></Button>
            );
        }
        return null;
    }
    const checkAnsweredDownload = (callid, status) => {
        if (status === 'ANSWERED') {
            return (
                <Button onClick={() => handleDownloadRecord(callid)}><Icon icon="ic:round-download-for-offline" color="#00E8E8" width="30px" height="30px" /></Button>
            );
        }
        return null;
    }
    // const showNoteOfCall = (callid) => {
    //     return (
            
    //     );
        // const res = await apiContact.show_note_call({callid});
        // console.log(res.data.data);
        // if(res.status == 200){
        //     return (
        //         <Button><Icon  icon="gg:notes" color="#34ebc3" width="30px" height="30px" /></Button>
        //     );
        // }else{
        //     return (
        //         <></>
        //     );
        // }
    // }
    const checkCallerOnContact = (caller) => {
        const foundObj = listContact.find(obj => obj.phone === caller);
        return foundObj ? foundObj.name : caller;
    };
    const checkCalleeOnContact = (callee) => {
        const foundObj = listContact.find(obj => obj.phone === callee);
        return foundObj ? foundObj.name : callee;
    };
    return (
        // <Container maxWidth={themeStretch ? false : 'xl'}>
        //     <HeaderBreadcrumbs
        //         // sx={{ mt: 3 }}
        //         heading={t('call_history')}
        //         links={[
        //             { name: '' }
        //         ]}
        //     />
        //     <Card>
        <>
            <Scrollbar>
                <TableContainer sx={{ minWidth: 1000 }}>
                    <Table>
                        <QueueListHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={TABLE_CALL_HISTORY}
                            rowCount={historyList.length}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            {historyList?.map((row, index) => {
                                const { callid, calldate, caller, callee, did, extension, type, duration, billsec, status, note } = row;
                                return (
                                    <TableRow
                                        hover
                                        key={callid}
                                        tabIndex={-1}
                                    >
                                        <TableCell align="left">
                                            {formatCalldate(type, calldate)}
                                        </TableCell>
                                        <TableCell component="th" scope="row" padding="none">
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <Icon icon="tabler:device-landline-phone" color="#0df505" />
                                                <Typography variant="subtitle2" noWrap>
                                                    {checkCallerOnContact(caller)}
                                                </Typography>
                                            </Stack>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <Icon icon="tabler:device-landline-phone" color="#f70505" />
                                                <Typography variant="subtitle2" noWrap>
                                                    {checkCalleeOnContact(callee)}
                                                </Typography>
                                            </Stack>
                                        </TableCell>
                                        <TableCell align="left">{statusHistory(status)}</TableCell>
                                        <TableCell align="left">{convertStringToTime(duration)}</TableCell>
                                        <TableCell align="left">{convertStringToTime(billsec)}</TableCell>
                                        <TableCell align="left">
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <Icon icon="tabler:device-landline-phone" color="#0515f7" />
                                                <Typography variant="subtitle2" noWrap>
                                                    {did}
                                                </Typography>
                                            </Stack>
                                        </TableCell>
                                        <TableCell align="left">{typeFormat(type, note)}</TableCell>
                                        {/* <TableCell align="left">
                                            {checkAnsweredPlay(callid, status)}
                                        </TableCell>
                                        <TableCell align="left">
                                            {checkAnsweredDownload(callid, status)}
                                        </TableCell> */}
                                        <TableCell align="left">
                                            {checkAnsweredPlay(callid, status)}
                                            {checkAnsweredDownload(callid, status)}
                                        </TableCell>
                                        <TableCell align="left"><Button onClick={() => handleOpenDialogNoteOfCall(callid)}><Icon icon={row?.is_comment?"material-symbols:note":"material-symbols:add-notes" } color={row?.is_comment?"#34ebc3":"grey"} width="30px" height="30px"/></Button></TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                        {isHistoryNotFound && (
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={11} sx={{ py: 2 }}>
                                        <SearchNotFound searchQuery={filterName} />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
            </Scrollbar>

            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalHistory}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />

            <DialogAnimate fullWidth maxWidth="md" open={isOpenModalPlayRecord} onClose={handleCloseModalPlayRecord}>
                <DialogPlayRecord isOpenModalPlayRecord={isOpenModalPlayRecord} handleCloseModalPlayRecord={handleCloseModalPlayRecord} callId={callIdRecord} />
            </DialogAnimate>
            <DialogAnimate fullWidth maxWidth="md" open={isOpenModalNoteOfCall} onClose={handleCloseModalNoteOfCall}>
                <DialogNoteOfCall isOpenModalNoteOfCall={isOpenModalNoteOfCall} handleCloseModalNoteOfCall={handleCloseModalNoteOfCall} callId={callIdRecord} />
            </DialogAnimate>
        </>

    );
}
